import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Education } from '@shared/models';
import { trackElement } from '@shared/utils';

@Component({
  selector: 'mojo-candidate-resume-education',
  templateUrl: './candidate-resume-education.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateResumeEducationComponent {
  @Input()
  educations: Education[];

  @Input()
  keywords: string[];

  trackElement = trackElement;
}
